import React from "react"
import { USER_ROLE } from "../../@constants/user"
import { USER_STATS_ROUTES } from "../../@constants/routes"
import AppLayout from "Layout"
import UserStatsPage from "./index"

export const UserStatsRoutes = {
    path: USER_STATS_ROUTES.PATH,
    title: USER_STATS_ROUTES.TITLE,
    subtitle: USER_STATS_ROUTES.SUBTITLE,
    icon: 'users-gear',
    iconWeight: 'light',
    access: USER_ROLE.ADMIN,
    element: <AppLayout />,
    children: [{
        element: <UserStatsPage />,
        index: true
    }]
}
